import { makeStyles } from '@material-ui/core';
import { Button } from 'components/Base';
import Icons from 'components/Icons';
import Dashboard from 'components/Layout/Dashboard/Dashboard';
import React, { useEffect } from 'react';
import { useAuth } from 'providers/AuthProvider/SessionAuthProvider';
import Router from 'components/Router/Router';
import ROUTES from 'consts/routes';

const { useHistory } = Router;

const useStyles = makeStyles({
  content: {
    textAlign: 'center',
    marginBottom: '1rem',
    paddingBottom: 0,
    height: '100%',
    width: '100%',
    position: 'absolute',
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  logoWrapper: {
    '& img': {
      maxWidth: '300px',
      maxHeight: 'calc(100% - 1rem)',
      marginBottom: '2rem'
    }
  },
  videoContainer: {
    width: '600px'
  }
});

const TrialExpired = () => {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    if (user && !(user as any).organization.trial_expired) {
      history.push(ROUTES.HOMEPAGE);
    }
    return;
  }, [user]);

  // Add Wistia video script on component mount
  useEffect(() => {
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/embed/medias/y811wvttab.jsonp';
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/assets/external/E-v1.js';
    script2.async = true;
    document.body.appendChild(script2);

    return () => {
      // Clean up scripts if necessary when component unmounts
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dashboard>
      <div className={classes.content}>
        <div style={{ marginBottom: '3rem' }}>
          <div className={classes.logoWrapper}>
            <Icons.LogoWithText />
          </div>

          <div style={{ fontWeight: 700, fontSize: '1.5rem' }}>
            Your free trial has ended
          </div>
          <div
            style={{
              margin: '0.5rem 0 1rem 0',
              fontSize: '1rem',
              maxWidth: '400px'
            }}
          >
            Thank you for exploring Fintegrate! To continue optimising your
            financial planning experience, get in touch to upgrade to a premium
            plan.
          </div>
          <a href="mailto:support@fintegrate.co.uk">
            <Button type="button">Contact us</Button>
          </a>
        </div>
        <div className={classes.videoContainer}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ fontSize: '1rem', maxWidth: '400px' }}>
              Join the hundreds of financial advisers and paraplanners who trust
              Fintegrate for comprehensive research, portfolio reviews, and
              client reporting.
            </div>
          </div>
          <div
            className="wistia_responsive_padding"
            style={{
              padding: '56.25% 0 0 0',
              position: 'relative',
              marginTop: '1rem',
              borderRadius: '4px',
              overflow: 'hidden'
            }}
          >
            <div
              className="wistia_responsive_wrapper"
              style={{
                height: '100%',
                left: 0,
                position: 'absolute',
                top: 0,
                width: '100%'
              }}
            >
              <div
                className="wistia_embed wistia_async_y811wvttab seo=true videoFoam=true"
                style={{ height: '100%', position: 'relative', width: '100%' }}
              >
                <div
                  className="wistia_swatch"
                  style={{
                    height: '100%',
                    left: 0,
                    opacity: 0,
                    overflow: 'hidden',
                    position: 'absolute',
                    top: 0,
                    transition: 'opacity 200ms',
                    width: '100%'
                  }}
                >
                  <img
                    src="https://fast.wistia.com/embed/medias/y811wvttab/swatch"
                    style={{
                      filter: 'blur(5px)',
                      height: '100%',
                      objectFit: 'contain',
                      width: '100%'
                    }}
                    alt=""
                    aria-hidden="true"
                    onLoad={() =>
                      ((
                        document.querySelector(
                          '.wistia_swatch'
                        ) as HTMLDivElement
                      ).style.opacity = '1')
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dashboard>
  );
};

export default TrialExpired;
